import { reactQueryDelete } from "@circle-react/helpers/backendRequestHelpers";
import { internalApi } from "@circle-react/helpers/urlHelpers";
import { communityLinkInvalidations } from "@circle-react/lib/queries/communityLinks";
import { useMutation } from "react-query";

import { t } from "@/i18n-js/instance";
import { ConfirmationModal } from "@/react/components/SettingsApp/CompassCompat/ConfirmationModal";

export interface DeleteLinkConfirmationProps {
  isOpen: boolean;
  link: {
    id: string;
    name: string;
  };
  onClose: () => void;
}

export const DeleteLinkConfirmation = ({
  isOpen,
  onClose,
  link,
}: DeleteLinkConfirmationProps) => {
  const { mutate: deleteLinkMutation, isPending: isDeleting } = useMutation({
    mutationFn: (data: any) =>
      reactQueryDelete(
        internalApi.communities.communityLinks.delete({
          communityLinkId: link.id,
        }),
        data,
      ),
    onSuccess: () => {
      void communityLinkInvalidations.all();
      onClose();
    },
  });

  return (
    <ConfirmationModal
      isOpen={isOpen}
      title={t("delete_link")}
      onClose={onClose}
      onCancel={onClose}
      onConfirm={() => deleteLinkMutation(undefined)}
      cancelText={t("cancel")}
      confirmText={isDeleting ? t("deleting") : t("delete")}
      disabled={isDeleting}
      confirmVariant="danger"
    >
      {t("delete_link_confirmation", { name: link.name })}
    </ConfirmationModal>
  );
};
